/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import clsx from '../../Utils/clsx';

const Select = ({ className, ...props }: React.HTMLProps<HTMLSelectElement>) => {
    return <select className={clsx('form-select', className)} {...props} />;
};

export const Option = (props: React.HTMLProps<HTMLOptionElement>) => {
    return <option {...props} />;
};

export default Select;
